var React = require('react');

function EditPencil (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2.6665 13.3334H5.33317L12.8618 5.8048C13.1221 5.54445 13.1221 5.12234 12.8618 4.86199L11.1379 3.13813C10.8776 2.87778 10.4554 2.87778 10.1951 3.13813L2.6665 10.6667V13.3334Z","stroke":"#8C8C8C","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M8 5.3335L10.6667 8.00016","stroke":"#8C8C8C","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

EditPencil.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = EditPencil;

EditPencil.default = EditPencil;
